export const convertRouterToLocation = (router: any) => {
  return {
    pathname: router.pathname,
    search: router.query,
    hash: "", // Next.js router doesn't have a hash equivalent
    state: {}, // Next.js router doesn't have a state equivalent
  };
};

export default convertRouterToLocation;
